/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Firsttryaccuracy2Inputs */

const zh_learn_firsttryaccuracy2 = /** @type {(inputs: Learn_Firsttryaccuracy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性正确率`)
};

const en_learn_firsttryaccuracy2 = /** @type {(inputs: Learn_Firsttryaccuracy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-try accuracy`)
};

const es_learn_firsttryaccuracy2 = /** @type {(inputs: Learn_Firsttryaccuracy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisión al primer intento`)
};

/**
* | output |
* | --- |
* | "First-try accuracy" |
*
* @param {Learn_Firsttryaccuracy2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_firsttryaccuracy2 = /** @type {((inputs?: Learn_Firsttryaccuracy2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Firsttryaccuracy2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_firsttryaccuracy2(inputs)
	if (locale === "en") return en_learn_firsttryaccuracy2(inputs)
	return es_learn_firsttryaccuracy2(inputs)
});
export { learn_firsttryaccuracy2 as "learn_firstTryAccuracy" }